<template>
<div class="chapter">
<div class="inner_page">
<div class="poetry">
<p class="poetry"><img alt="51DpS555NfL._SY346_Large.jpg" height="686" src="d2d_images/image005.jpg" width="430"/></p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c003.vue?75e42734